import React from 'react'
import Link from 'gatsby-link'
import Game from "../components/rgb/components/Game";
import StoreLinks from "../components/storeLinks";

const IndexPage = () => (
  <div>
    <h1>Welcome</h1>
    <p>RGB Logic is a colo(u)rful Sudoku like game designed for iOS and Android. This tutorial will guide you through how to play it.</p>

    <StoreLinks androidStoreLink="https://play.google.com/store/apps/details?id=uk.amimetic.rgb.logic.pro&hl=en_GB"
                iOSStoreLink="https://itunes.apple.com/gb/app/rgb-logic-buchstabensalat-logic-puzzles/id1097300530?mt=8"
    />

  <p>RGB Logic is really simple to play (but can be tricky to solve). Just tap or click on a square to change the colour. Tap again to go to next colour.</p>

      <p>The fundamental rule of RGB logic is <strong>You must place one of each colour in every row and column</strong>. This holds for all puzzles (even the most complex).</p>

      <p>You must also match the clues on the outside. <strong>The closest occupied square to the outside clues must match the colour of the clue</strong>.
      You should match downwards from the top, rightwards from the left and so on.
      </p>

      <p>We'll start with the simplest possible puzzle. It is a 2x2 grid with 2 colours.
          As it is only 2x2 a solution will have all squares occupied. You just need to fill in the centre,
          matching the closed clues above, to the right, below and to the left of the play area.</p>

        <Game seed="into" gridSize={2} colourCount={2} remove={0} title="The most simple puzzle"/>

      <p>This puzzle is 3x3 with 3 colours. Fill in one of each colour in every row and column. As there is a complete set of clues it
      is pretty simple. Just match the squares with the clues next to it.</p>

        <Game seed="into" gridSize={3} colourCount={3} remove={0} title="3x3"/>

      <p>This puzzle is 3x3 but has only 2 colours. So one item in each row or column should be left blank. There is more than one valid solution.</p>

    <Game seed="into2" gridSize={3} colourCount={2} remove={2} title="3x3, 2 colours"/>

      <p>Let's make things more interesting. You now have fewer clues.</p>

      <Game seed="into2" gridSize={3} colourCount={3} remove={8} title="Getting more interesting"/>

      <p>Now let's make it bigger. There are 3 colours so one item in every row and column should be left blank.</p>

      <Game seed="into2" gridSize={4} colourCount={3} remove={6} title="4x4, 3 colours"/>

      <Game seed="into6" gridSize={4} colourCount={3} remove={10} title="4x4, 3 colours, harder"/>

      <Game seed="into632" gridSize={4} colourCount={4} remove={10} title="4x4, 4 colours"/>

      <h1>Download</h1>

      <p>Get RGB Logic for iOS and Android. It is free and comes with new puzzles every day. In the App puzzles go up to 7x7, introduce inactive squares and get much harder.</p>

    <StoreLinks androidStoreLink="https://play.google.com/store/apps/details?id=uk.amimetic.rgb.logic.pro&hl=en_GB"
                iOSStoreLink="https://itunes.apple.com/gb/app/rgb-logic-buchstabensalat-logic-puzzles/id1097300530?mt=8"/>

      <h1>Share</h1>

      <p>Please let others know about RGB Logic. It is fun and free. And might make you smarter. Thanks.</p>

      <a href="http://www.facebook.com/sharer/sharer.php?u=https://rgb-logic.amimetic.co.uk"
         alt="Share on Facebook"><div className="webLinkLarge">Share on Facebook</div></a>

  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js